module.exports = __webpack_public_path__ + "static/media/mail.43966684.svg";